import { useNps } from "@/contexts/Nps/context";
import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import style from "./style.module.css";

export function Filtro(){
  const { getNpsAtendimentos } = useNps();
  const [searchParams] = useSearchParams();
  const [filtro, setFiltro] = useState<string>("mais_recente");
  const [nomeCliente, setNomeCliente] = useState<string>("");
  const currentQueryParams = Object.fromEntries(searchParams.entries());

  function handleFiltroChange(event: SelectChangeEvent) {
    const newFiltro = event.target.value as string;
    setFiltro(newFiltro);
  }

  function handleChangeCliente(event: React.ChangeEvent<HTMLInputElement>) {
    const newNomeCliente = event.target.value;
    setNomeCliente(newNomeCliente);
  }

  useEffect(() => {
    const params = { 
      maisRecente: filtro !== "mais_recente" ? false : true,
      ordemAlfabetica: filtro !== "ordem_alfabetica" ? false : true,
      nomeCliente: nomeCliente,
      ...currentQueryParams
    };
    getNpsAtendimentos(params);
  }, [filtro, nomeCliente]);

  return(
    <div className={style.container_filtro}>
      <Select 
        onChange={handleFiltroChange} 
        value={filtro} 
        displayEmpty
        renderValue={(item) => {
          const displayText =
              item === "mais_recente" ? "Mais recente" :
              item === "menos_recente" ? "Menos recente" :
              item === "ordem_alfabetica" ? "Ordem alfabética" :
              item;
          return (
            <span className={style.filtro}>Filtrar por: <span>{displayText}</span></span>
          )
        }}
        sx={{
          height: '2.4rem',
          border: '1px solid #4C4E6480',
          borderRadius: '24px',
          backgroundColor: 'white',
          color: '#4C4E64',

          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },

          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #666CFF',
          }

        }}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 1,
              width: 'auto',
            },
          },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
        }}
      >
        <MenuItem value={"mais_recente"}>Mais recente</MenuItem>
        <MenuItem value={"menos_recente"}>Menos recente</MenuItem>
        <MenuItem value={"ordem_alfabetica"}>Ordem alfabética</MenuItem>
      </Select>

      <div className={style.input_filtro}>
        <SearchIcon/>
        <input 
          type="text"
          onChange={handleChangeCliente} 
          value={nomeCliente}
          placeholder={'Busca'}
        />
      </div>
      
    </div>
  )
}